import React from 'react'

function SampleCompZwrotAkcji({name}) {
    return (
        <div className="zwrot-akcji-idea">
           {name}
        </div>
    )
}

export default SampleCompZwrotAkcji;
